import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Select } from 'antd';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useSelector } from 'react-redux';

export default function ArtistsFilter({ updateRoute }) {
  const router = useRouter();

  const [searchFilter, setsearchFilter] = useState('');
  const roomsData = useSelector((state) => state.nftReducer.roomsData);

  let {
    filter: filter,
    sortBy: sortBy,
    searchQuery: searchQuery,
    room: roomFilter,
  } = router.query;

  useEffect(() => {
    if (searchQuery) {
      setsearchFilter(searchQuery);
    } else if (!searchQuery && searchFilter.length > 0) {
      setsearchFilter('');
    }
  }, [searchQuery]);

  const selectRoom = (option) => {
    if (option && option.length > 0) {
      updateRoute({ room: option });
    } else {
      updateRoute(['room', ''], 'remove');
    }
  };

  return (
    <div className="w-full">
      <div className="px-4">
        <div className="main__filter">
          {/* //music btn */}
          <div className="main__filter_child main__filter_btns filter-wrap-mr-30">
            <button
              className={`filter__btn 
              ${
                !filter || (filter && !filter.includes('NA-Music'))
                  ? 'filter_btn_active'
                  : ''
              }`}
              type="button"
              onClick={(e) => {
                if (filter && filter.includes('NA-Music')) {
                  if (filter && filter.includes('Artwork and More')) {
                    updateRoute(
                      ['filter', ['NA-Music', 'Artwork and More']],
                      'removeFromArr',
                    );
                  } else {
                    updateRoute(['filter', 'NA-Music'], 'removeFromArr');
                  }
                } else {
                  updateRoute(['filter', 'NA-Music'], 'addToArr');
                }
              }}
            >
              Music
            </button>
          </div>

          {/* //artwork btn */}
          <div className="main__filter_child main__filter_btns filter-wrap-mr-30">
            <button
              className={`filter__btn 
          ${
            filter && filter.includes('Artwork and More')
              ? 'filter_btn_active'
              : ''
          }
          `}
              type="button"
              onClick={(e) => {
                if (filter && filter.includes('Artwork and More')) {
                  updateRoute(['filter', 'Artwork and More'], 'removeFromArr');
                } else {
                  if (!filter || (filter && !filter.includes('NA-Music'))) {
                    updateRoute(
                      ['filter', ['NA-Music', 'Artwork and More']],
                      'addToArr',
                    );
                  } else {
                    updateRoute(['filter', 'Artwork and More'], 'addToArr');
                  }
                }
              }}
            >
              Artwork and More
            </button>
          </div>

          {/* //search field */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateRoute({ searchQuery: searchFilter });
            }}
            className="main__filter_child main__filter-search"
          >
            <input
              style={{ width: '100%' }}
              type="text"
              placeholder="Search for MusicArtists"
              value={searchFilter}
              onChange={(e) => setsearchFilter(e.target.value)}
              required
            />
            <div
              style={{
                position: 'absolute',
                top: 10,
                right: 0,
              }}
            >
              {searchFilter && searchFilter.length > 0 && (
                <button
                  type="button"
                  style={{
                    right: 50,
                  }}
                  onClick={() => {
                    setsearchFilter('');
                    if (searchQuery && searchQuery.length > 0) {
                      updateRoute(['searchQuery', ''], 'remove');
                    }
                  }}
                  className="close_icon"
                >
                  <HighlightOffIcon />
                </button>
              )}{' '}
              <button type="submit">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" />
                </svg>
              </button>
            </div>
          </form>

          {/* //rooms  */}
          <div className="main__filter_child main__filter-wrap filter-wrap-mr-30">
            <Select
              mode="multiple"
              placeholder="Select Rooms"
              maxTagCount={'responsive'}
              optionLabelProp="label"
              value={
                roomsData &&
                roomsData.length > 0 &&
                roomFilter &&
                roomFilter &&
                roomFilter.length > 0
                  ? Array.isArray(roomFilter)
                    ? [...roomFilter]
                    : [roomFilter]
                  : []
              }
              onChange={(value) => {
                selectRoom(value);
              }}
              className="multi_select_same_ui w-full"
              style={{ minWidth: 230 }}
            >
              {roomsData &&
                roomsData.map((ele) => {
                  return (
                    <Select.Option
                      key={ele.id}
                      value={ele.id}
                      label={
                        ele.RoomName.length > 10
                          ? ele.RoomName.substring(0, 10) + '...'
                          : ele.RoomName
                      }
                    >
                      {ele.RoomName}
                    </Select.Option>
                  );
                })}
            </Select>
          </div>

          {/* //sort by */}
          <div
            className="main__filter_child main__filter-wrap"
            style={{ minWidth: 200 }}
          >
            <select
              className="main__select"
              name="status"
              onChange={(event) => {
                const { value, options, selectedIndex } = event?.target;
                updateRoute({ sortBy: value });
              }}
              value={sortBy}
              style={{ minWidth: 200 }}
            >
              <option
                style={{ display: 'none' }}
                value="sort"
                selected
                disabled
              >
                Sort by
              </option>
              <option value="followers" data-order="desc">
                Followers
              </option>
              <option value="nftsCountLive" data-order="desc">
                Popularity
              </option>
              <option value="creationDate" data-order="desc">
                Recently Created
              </option>
              <option value="lowerCaseName" data-order="asc">
                Alphabetically
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
